export var TrendingTier;
(function (TrendingTier) {
    TrendingTier["NoTier"] = "no-tier";
    TrendingTier["Gold1"] = "gold-1";
    TrendingTier["Gold2"] = "gold-2";
    TrendingTier["Gold3"] = "gold-3";
    TrendingTier["Platinum1"] = "platinum-1";
    TrendingTier["Platinum2"] = "platinum-2";
    TrendingTier["Platinum3"] = "platinum-3";
    TrendingTier["Diamond1"] = "diamond-1";
    TrendingTier["Diamond2"] = "diamond-2";
    TrendingTier["Diamond3"] = "diamond-3";
    TrendingTier["Elite"] = "elite";
})(TrendingTier || (TrendingTier = {}));
//# sourceMappingURL=tier.js.map